import React, { useState, useEffect, useRef, useCallback } from 'react';
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';
import { SelectPicker, DatePicker, Dropdown, Placeholder, Whisper, Button, Popover, Message, useToaster, Tooltip, Input, Modal} from "rsuite";
import "rsuite/SelectPicker/styles/index.css";
import CreatableSelect from "react-select/creatable";
import { components } from 'react-select';
import customCarretArrow from "../images/IconCaretBlue.svg";
import debounce from 'lodash.debounce';
import { Center, ChakraProvider, useToast, Wrap } from '@chakra-ui/react'

function FinancialLabelsSettings() {


    const abortControllerRef = useRef(null);
    const [isLoading, setLoading] = useState(false); 
    const [isLoading1, setLoading1] = useState(false); 
    const apiEndPoint = process.env.REACT_APP_ETF_API_ENDPOINT;
    const [reportData, setReportData] = useState([]);
    const [reportCount, setReportCount] = useState(0);
    const [searchInput, setSearchInput] = useState("");
    const userid = localStorage.getItem("novauserid");


    const toast = useToast()
    const toastIdRef = React.useRef()

    // EQUAL HEIGHT DIV
    const cellRefs = useRef([]);

    useEffect(() => {
        // Reset heights first
        cellRefs.current.forEach((ref) => {
            if (ref) ref.style.height = 'auto';
        });

        // Find max height
        const maxHeight = Math.max(...cellRefs.current.map(ref => ref?.offsetHeight || 0));

        // Apply max height to all
        cellRefs.current.forEach((ref) => {
            if (ref) ref.style.height = `${maxHeight}px`;
        });
    }, []);



      const [assetsTypeData, setAssetsTypeData] = useState([]);

    useEffect(() => {
            const fetchCountryList = async () => {
              const url = `${apiEndPoint}/get_zakat_assettype`;
              const payload = {
                data: {
                  user_id: userid // Replace with the actual user_id if dynamic
                }
              };
          
              try {
                const response = await fetch(url, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(payload),
                });
          
                if (!response.ok) {
                  throw new Error('Network response was not ok');
                }
          
                const responseData = await response.json();
                const data = responseData.data; // Flatten the response
        
                const formattedCountryData = data.asset_types.map((asset) => ({
                  label: asset.asset_type,
                  value: asset.asset_type,
                }));
        
                setAssetsTypeData(formattedCountryData);
          
              } catch (error) {
                //setErrorMessage(error.message);
               // setMessageType('error');
                return false;
              }
            };
          
            fetchCountryList();
          }, []);

    const [changedItems, setChangedItems] = useState([]);

    const handleChange = (newValue, id) => {
  const selectedValue = newValue ? newValue.value : "";

  // Update reportData using id
  const updatedData = reportData.map(item =>
    item.id === id ? { ...item, asset_type: selectedValue } : item
  );
  setReportData(updatedData);

  // Track only changed items by id
  const changedItem = {
    id: id,
    asset_type: selectedValue,
  };

  setChangedItems(prev => {
    const existingIndex = prev.findIndex(item => item.id === id);
    if (existingIndex !== -1) {
      const updated = [...prev];
      updated[existingIndex] = changedItem;
      return updated;
    } else {
      return [...prev, changedItem];
    }
  });
};

    

    const CustomDropdownIndicator = (props) => (
        <components.DropdownIndicator {...props}>
            <img
                src={customCarretArrow}
                alt="dropdown arrow"
                style={{ width: 11, height: 11 }}
            />
        </components.DropdownIndicator>
    );

     const fetchGlobalReport = async () => {
          setLoading(true);
      
          // Cancel the previous request if any
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
        }
    
         // Create a new AbortController for the current request
         const controller = new AbortController();
         abortControllerRef.current = controller;
    
        try {
            const apiUrl = `${apiEndPoint}/get_zakat_library`;
            const requestData = {
              data: {
                user_id: userid,
                 q:searchInput,
              }
            };
            console.log(JSON.stringify(requestData));
            const response = await fetch(apiUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(requestData),
              signal: controller.signal
            });
      
            const jsonData = await response.json();
            const { status, message, total_count, library } = jsonData.data;
            if (status == "success") {
              setLoading(false);
              setReportCount(total_count);
              setReportData(library);
            } else {
                setLoading(false);
              console.error("Error: ", message);
            }
          } catch (error) {
            setLoading(false);
            if (error.name === "AbortError") {
              console.log("Request cancelled");
            }
            else{
                setLoading(false);
            console.error("Error fetching data:", error.message);
            }
            return false;
          }
        };
      
        const debouncedFetchGlobalReport = useCallback(
          debounce(() => {
            fetchGlobalReport();
          }, 1000),
          [searchInput] // Only debounce on search input changes
        );
      
        useEffect(() => {
          debouncedFetchGlobalReport();
          return () => {
            debouncedFetchGlobalReport.cancel();
          };
        }, [searchInput]);
      
        
        const handleSearch = (event) => {
          console.log(event.target.value);        
          setSearchInput(event.target.value);
        };



 const handleSubmit = async () => {

    if (!changedItems || changedItems.length === 0) {
        toastIdRef.current = toast({ description: 'Please make some changes before submitting', status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        return false;
    }

    try {

        setLoading1(true);

                const response = await fetch(`${apiEndPoint}/update_zakat_library`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ user_id: userid, data: changedItems })
                });

                if (response.ok) {
                const result = await response.json();
                    const { status, message, updated_count } = result.data;
                
                    if (status === "success") {
                    toastIdRef.current = toast({ description: message, status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
                    setLoading1(false);
                    fetchGlobalReport();

                } else {
                    setLoading1(false);
                    toastIdRef.current = toast({ description: message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
                    console.error("Update failed with status:", status);
                    return false;
                }

                } else {
                    setLoading1(false);
                console.error("Update failed");
                }
                } catch (err) {
                    setLoading1(false);
                toastIdRef.current = toast({ description: err.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
                }
};

 const handleClearFilters = () => {
      setSearchInput("");      
 };



    return (
        <>
            <Sidebar />
            <ChakraProvider resetCSS={false}></ChakraProvider>

            <div id='header'>
                <div className='logo'>
                    <div className='logo_icon'>
                        <img src={Logo} />
                    </div>
                    <div className='brand_name'>Zakat Library</div>
                </div>

                <div className='header_table_filter' style={{ width: "auto" }}>
                    <div className='searchfield' style={{ maxWidth: 270 }}>
                        <button className='btn_search'><i className='icon-search'></i></button>
                        <input type='text' className='filter_searchfield' placeholder='Search by labels or Assets' onChange={handleSearch}   value={searchInput} />
                    </div>

                    <a href='javascript:void(0)' className="btn_clear_filter"  style={{textDecoration:"none"}} onClick={handleClearFilters}>Clear Filters</a>
                </div>
            </div>
            <div className="container-fluid content pb-5 mt-4">
                <div className='sector_title_desc_row'>
                    <div>
                        <h5>Labels Settings</h5>
                        <p>Manage and customize financial labels by editing, merging, or adding new labels and asset types.</p>
                    </div>
                    <Button className='btn_create_group_save' onClick={handleSubmit} loading={isLoading1}>Save</Button>
                </div>
{isLoading && ( <Placeholder.Grid rows={20} columns={9} active style={{paddingLeft:20, paddingRight:20, paddingTop:12}} /> )}
{!isLoading && (
                <div className='tab_content_main' style={{ padding: 20, borderRadius: 16, backgroundColor: '#FFF', boxShadow: '0px 2px 24px 1px rgba(225, 225, 225, 0.80), 0px 2px 24px 1px rgba(225, 225, 225, 0.80)' }}>
                    <div className='zakat_table__row'>
                        {reportData.length > 0 ? (
  reportData
    .reduce((chunks, item, index) => {
      const chunkIndex = Math.floor(index / 15);
      if (!chunks[chunkIndex]) {
        chunks[chunkIndex] = [];
      }
      chunks[chunkIndex].push(item);
      return chunks;
    }, [])
    .map((chunk, chunkIndex) => (
      <div className='sector_industry_table' key={`sector_table_${chunkIndex}`}>
        <div className='table-responsive' style={{ paddingBottom: 0, maxHeight: 'inherit' }}>
          <table className='table esg_library_table'>
            <thead>
              <tr>
                <th>Labels</th>
                <th>
                  <div className="esg_library_th" style={{ textAlign: 'center' }}>Type of Assets</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {chunk.map((item, index) => {
  const actualIndex = chunkIndex * 15 + index;
  return (
    <tr key={`row_${chunkIndex}_${index}`}>
      <td>
        <div className='label_cell equal-cell' ref={(el) => cellRefs.current[0] = el}>
          {item.label}
        </div>
      </td>
      <td>
        <div className='dropdown__cell equal-cell' ref={(el) => cellRefs.current[1] = el}>
           <CreatableSelect
          isClearable
          key={item.id}
          onChange={(newValue) => handleChange(newValue, item.id)}
          options={assetsTypeData}
          className="dropdown__assets_type"
          value={assetsTypeData.find(opt => opt.value === item.asset_type) || null}
          components={{ DropdownIndicator: CustomDropdownIndicator }}
          menuPortalTarget={document.body}
          menuShouldBlockScroll={true}
          placeholder="-"
          styles={{
            menu: (base) => ({
              ...base,
              maxHeight: 150,
              overflowY: 'auto',
            }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          />
        </div>
      </td>
    </tr>
  );
})}

            </tbody>
          </table>
        </div>
      </div>
    ))
) : (

    <div style={{width:'100%',padding:'40px 0'}}>
      <h5 style={{fontSize:20,fontWeight:500,textAlign:'Center'}}>No data available</h5>
    </div>
 
)}
                    </div>
                </div>
)}
            </div>


           

        </>
    );
}

export default FinancialLabelsSettings;
